import { html, nothing } from 'lit-html';

/**
 * Horse-specific card templates
 * Demonstrates the CardStack flexibility with a completely different use case
 */

/**
 * Landing page template
 */
export function renderLandingCard(item, stats) {
  return html`
    <div class="horse-landing">
      <div class="horse-landing-emoji">🐴</div>
      <h1 class="horse-landing-title">Horse Tinder</h1>
      <p class="horse-landing-sub">Find your perfect equine match</p>

      <div class="horse-stats">
        <div class="horse-stat">
          <span class="horse-stat-value">${stats.total}</span>
          <span class="horse-stat-label">Horses</span>
        </div>
        <div class="horse-stat">
          <span class="horse-stat-value">${stats.liked}</span>
          <span class="horse-stat-label">Liked</span>
        </div>
        <div class="horse-stat">
          <span class="horse-stat-value">${stats.passed}</span>
          <span class="horse-stat-label">Passed</span>
        </div>
      </div>
    </div>
    <div class="horse-hint">Swipe up to start browsing</div>
  `;
}

/**
 * Horse card template
 */
export function renderHorseCard(horse, index, isLiked, isPassed) {
  return html`
    <div class="horse-card">
      <div class="horse-image-container">
        <img
          class="horse-image"
          src="${horse.image}"
          alt="${horse.name}"
          loading="lazy"
        />
        <video
          class="horse-video"
          src="${horse.video}"
          muted
          playsinline
          preload="auto"
        ></video>
        <div class="horse-image-gradient"></div>
      </div>

      <div class="horse-info">
        <div class="horse-header">
          <h2 class="horse-name">${horse.name}</h2>
          <span class="horse-age">${horse.age} yrs</span>
        </div>

        <div class="horse-meta">
          <span class="horse-breed">${horse.breed}</span>
          <span class="horse-dot">•</span>
          <span class="horse-color">${horse.color}</span>
        </div>

        <p class="horse-bio">${horse.bio}</p>

        <div class="horse-location">
          <span class="horse-location-icon">📍</span>
          <span>${horse.location}</span>
        </div>

        ${isLiked ? html`<div class="horse-badge liked">Liked!</div>` : nothing}
        ${isPassed ? html`<div class="horse-badge passed">Passed</div>` : nothing}
      </div>
    </div>

    <div class="horse-hint">
      ${isLiked || isPassed
        ? 'Swipe up or down to browse'
        : 'Swipe right to like / left to pass'}
    </div>
  `;
}

/**
 * End card template (shown after all horses)
 */
export function renderEndCard(stats) {
  return html`
    <div class="horse-end">
      <div class="horse-end-emoji">🎉</div>
      <h2 class="horse-end-title">That's all folks!</h2>
      <p class="horse-end-sub">You've seen all the horses</p>

      <div class="horse-end-stats">
        <p>You liked <strong>${stats.liked}</strong> horses</p>
        <p>You passed on <strong>${stats.passed}</strong> horses</p>
      </div>

      <p class="horse-end-cta">Swipe down to browse again</p>
    </div>
    <div class="horse-hint">Swipe down to go back</div>
  `;
}

/**
 * Left overlay (pass)
 */
export function renderLeftOverlay() {
  return html`NOPE`;
}

/**
 * Right overlay (like)
 */
export function renderRightOverlay() {
  return html`LIKE`;
}
